export const beforeItems: string[] = [
  'Domeniche sera passate a cercare schede online',
  'Materiali casuali che non si collegano tra loro',
  'Nessuna progressione chiara da un anno al successivo',
  'Esercizi mancanti proprio quando servono',
  'Verifiche e griglie da costruire ogni volta da zero',
]

export const afterItems: string[] = [
  'Un anno intero già pianificato, unità per unità',
  'Teoria, esempi svolti ed esercizi in un unico documento',
  'Una progressione chiara dalla 1ª primaria al biennio',
  'Ogni attività su tre livelli: base, intermedio, avanzato',
  'Verifica finale, soluzioni complete e rubrica già pronte',
]

export const transformationStats: [string, string][] = [
  ['600', "PAGINE PRONTE ALL'USO"],
  ['8 UNITÀ', 'IN OGNI SINGOLO ANNO'],
  ['100%', 'SOLUZIONI INCLUSE'],
]
